<template>
  <div class="d-flex flex-column flex-column-fluid">
    <!-- Toolbar -->
    <div id="kt_app_toolbar" class="app-toolbar py-6 py-lg-6">
      <div
        id="kt_app_toolbar_container"
        class="app-container container-fluid d-flex flex-stack"
      >
        <div
          class="page-title d-flex flex-column justify-content-center flex-wrap me-3"
        >
          <h1
            class="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0"
          >
            {{ $t("common.app_name") }}
          </h1>
          <ul
            class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1"
          >
            <li class="breadcrumb-item text-muted">
              <a href="#" class="text-muted text-hover-primary">{{
                $t("common.home")
              }}</a>
            </li>
            <li class="breadcrumb-item">
              <span class="bullet bg-gray-400 w-5px h-2px"></span>
            </li>
            <li class="breadcrumb-item text-muted">{{ $t("prv.title") }}</li>
          </ul>
        </div>
        <div class="d-flex align-items-center gap-2 gap-lg-3">
          <button
            @click="$router.go(-1)"
            class="btn btn-light"
            style="
              font-weight: 600;
              padding: 8px 20px;
              margin-left: 15px;
              background: #d7d7d745;
            "
          >
            {{ $t("common.back") }}
            <i
              class="fa fa-arrow-left"
              style="color: #07c232; margin-right: 10px"
            ></i>
          </button>
        </div>
      </div>
    </div>
    <!-- Content -->

    <div id="kt_app_content" class="app-content flex-column-fluid">
      <div id="kt_app_content_container" class="app-container container-fluid">
        <div
          v-if="isLoading == true"
          style="
            font-weight: 800;
            border-radius: 10px;
            padding: 50px;
            font-size: large;
            text-align: center;
            background: #73737326;
          "
          class="loader text-success"
        >
          {{ $t("common.loading") }}
          <div class="spinner-border text-success" role="status">
            <span class="sr-only"></span>
          </div>
        </div>
        <div v-if="isLoggedIn == false && isLoading == false" class="col-12">
          <div class="card text-center p-5 not-login">
            <span class="icon"><i class="bi bi-person-badge"></i></span>
            <h3 class="mb-4">{{ $t("common.please_login_to_continue") }}</h3>
            <span>
              <a href="login" class="btn btn-success">
                {{ $t("common.login") }} <i class="fa fa-sign-in"></i>
              </a>
            </span>
          </div>
        </div>
        <div class="row g-5 g-xl-10 mb-5 mb-xl-10">
          <div
            class="col-md-12"
            v-if="isLoading == false && isLoggedIn == true"
          >
            <div class="row">
              <div class="col-xl-5">
                <!--begin::Engage widget 1-->
                <div class="card h-xl-80" dir="ltr">
                  <!--begin::Body-->
                  <div class="card-body d-flex flex-column flex-center">
                    <!--begin::Heading-->
                    <div class="mb-2">
                      <!--begin::Title-->
                      <h1 class="fw-semibold text-gray-800 text-center lh-lg">
                        {{ $t("prv.title") }}
                        <br />
                        <span class="fw-bolder">
                          {{ $t("prv.new_booking") }}</span
                        >
                      </h1>
                      <!--end::Title-->
                      <!--begin::Illustration-->
                      <div class="py-10 text-center">
                        <img
                          src="assets/img/webinar.png"
                          class="theme-light-show w-150px"
                          alt=""
                        />
                        <img
                          src="assets/img/webinar.png"
                          class="theme-dark-show w-150px"
                          alt=""
                        />
                      </div>
                      <!--end::Illustration-->
                    </div>
                    <!--end::Heading-->
                    <!--begin::Links-->
                    <div class="text-center mb-1">
                      <!--begin::Link-->
                      <a
                        style="background-color: #07c232"
                        class="btn btn-sm btn-success btn-lg me-2 w-150px"
                        href="sessions-list"
                        >{{ $t("prv.new_booking") }}
                        <i class="fa fa-plus-circle"></i>
                      </a>

                      <!--end::Link-->
                    </div>
                    <!--end::Links-->
                  </div>
                  <!--end::Body-->
                </div>
                <!--end::Engage widget 1-->
              </div>
              <div class="col-xl-7 mb-xl-10">
                <!--begin::List widget 20-->
                <div class="col-xl-12 session-tab">
                  <div class="card mb-5 mb-xl-8 mt-5">
                    <!--begin::Body-->
                    <div class="card-body pb-0">
                      <ul
                        class="nav nav-pills mb-3"
                        style="display: flex; justify-content: center"
                        id="pills-tab"
                        role="tablist"
                      >
                        <li class="nav-item">
                          <a
                            class="nav-link active"
                            id="pills-upcoming-tab"
                            data-bs-toggle="pill"
                            href="#pills-upcoming"
                            role="tab"
                            aria-controls="pills-upcoming"
                            aria-selected="true"
                          >
                            {{ $t("prv.tabs.upcoming") }}
                            <i class="fas fa-clock"></i>
                          </a>
                        </li>

                        <li class="nav-item">
                          <a
                            class="nav-link"
                            id="pills-previous-tab"
                            data-bs-toggle="pill"
                            href="#pills-previous"
                            role="tab"
                            aria-controls="pills-previous"
                            aria-selected="false"
                          >
                            {{ $t("prv.tabs.previous") }}
                            <i class="fas fa-list"></i>
                          </a>
                        </li>

                        <li class="nav-item">
                          <a
                            class="nav-link"
                            id="pills-restored-tab"
                            data-bs-toggle="pill"
                            href="#pills-restored"
                            role="tab"
                            aria-controls="pills-restored"
                            aria-selected="false"
                          >
                            {{ $t("prv.tabs.restored") }}
                            <i class="fas fa-history"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div class="tab-content">
                    <div
                      class="tab-pane fade show active"
                      id="pills-upcoming"
                      role="tabpanel"
                      aria-labelledby="pills-upcoming-tab"
                    >
                      <FutureSessionsList />
                    </div>
                    <div
                      class="tab-pane fade"
                      id="pills-previous"
                      role="tabpanel"
                      aria-labelledby="pills-previous-tab"
                    >
                      <PastSessionsList />
                    </div>
                    <div
                      class="tab-pane fade"
                      id="pills-restored"
                      role="tabpanel"
                      aria-labelledby="pills-restored-tab"
                    >
                      <RefundedSessionsList />
                    </div>
                  </div>
                </div>
                <!--end::List widget 20-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--begin::Col-->

    <!--end::Col-->
  </div>
  <Favorites ref="favRef" />
</template>

<script>
import { apiUrl, baseUrl } from "@/utils/api";
import FutureSessionsList from "./future.vue";
import RefundedSessionsList from "./refunded.vue";
import PastSessionsList from "./past.vue";
export default {
  name: "SessionsList",
  components: {
    FutureSessionsList,
    RefundedSessionsList,
    PastSessionsList,
  },
  data() {
    return {
      /* --------- قائم كما هو --------- */
      categoriesData: [],
      selectedCategoryId: null,
      selectedSubCategoryId: null,
      selectedChildCategoryId: null,
      isLoading: true,
      slotsLoading: false,
      isLoggedIn: false,
      token: localStorage.getItem("access_token"),

      /* --------- جديد --------- */
      instructors: [], // البيانات التى سنعرضها
      pagerLinks: {}, // prev / next / first / last
      pagerMeta: {}, // current_page, links[], ...
      instructorImgPath: baseUrl + "/images/instructors/", // عدِّل المسار إذا لزم

      /* أي شيء آخر */
      defaultImage: "/assets/img/acad-icon.png",
    };
  },

  computed: {
    /** التخصصات حسب الفئة المختارة */
  },

  mounted() {
    this.getCategories();
  },

  methods: {
    /** جلب الفئات من الـAPI */
    async getCategories() {
      this.isLoading = true;
      try {
        const res = await fetch(`${apiUrl}/live-sessions/get-categories`, {
          headers: {
            Authorization: `Bearer ${this.token}`,
            "Content-Type": "application/json",
          },
        });

        if (res.ok) {
          this.isLoggedIn = true;
          var categoriesDataResponse = await res.json();

          this.categoriesData = categoriesDataResponse.categories;
        } else {
          console.error("Failed to fetch categories");
        }
      } catch (e) {
        console.error("Error fetching categories:", e);
      } finally {
        this.isLoading = false;
      }
    },

    /* ---------- مساعدات صغيرة للعرض ---------- */
  },
};
</script>

<style scoped>
.swal2-container.no-flex-swal {
  display: block !important;
  text-align: center;
}

/* المودال نفسه */
.no-flex-swal {
  position: absolute !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
}
</style>
